import styled from 'styled-components';

export const OnBoardingSpecialistsWrapper = styled.div`
  & .specialists-title {
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: #1d201f;
    margin-bottom: 30px;
    padding: 0 16px;
  }

  & .specialists-list {
    display: flex;
    flex-direction: column;

    & > div {
      border-top: 1px solid #eeeeee;
      padding-left: 16px;
      padding-right: 16px;

      &:active {
        background: #f2f4f7;
      }

      &:last-child {
        border-bottom: 1px solid #eeeeee;
      }

      & > ion-icon {
        display: none;
      }

      & > div {
        padding: 16px 0;
      }
    }
  }
`;
